import { Crown } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms';

export const PolicyFitBadgePremium = () => {
  return (
    <div className="flex-1 px-2 border border-dashed border-gray-200 rounded-lg p-4 pt-2 mr-2">
      <div className="flex items-center justify-between gap-1 mb-3">
        <h4 className="text-sm font-semibold text-stone-400">YOUR POLICY FIT</h4>
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Crown className={`d-6 rounded-full p-1 text-[#7F00FF]`} />
            </TooltipTrigger>
            <TooltipContent
              side="left"
              className="max-w-lg bg-white text-black space-y-1 p-4 border shadow-sm border-gray-300"
            >
              <h3 className="text-sm font-semibold">YOUR POLICY FIT</h3>
              <p className="text-justify leading-relaxed">
                Easily check how a merchant aligns with your Acceptable Use Policy (AUP). Upload
                your AUP and automatically match the merchant's activities, products, and risk
                factors against your policy.
              </p>
              <p className="font-semibold">Examples:</p>
              <div className="bg-gray-50 rounded-md border overflow-hidden">
                <div className="border-b border-gray-200 flex">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Merchants selling unverified dietary supplements
                  </div>
                  <div className="w-20 bg-orange-400/10 flex items-center justify-center">
                    <span className="text-xs text-orange-400">Prohibited</span>
                  </div>
                </div>
                <div className="border-b border-gray-200 flex">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Sale of historical artifacts in the UAE
                  </div>
                  <div className="w-20 bg-red-500/10 flex items-center justify-center">
                    <span className="text-red-500 text-xs">Prohibited</span>
                  </div>
                </div>
                <div className="border-b border-gray-200 flex">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Marketing lead-generation services in Singapore
                  </div>
                  <div className="w-20 bg-orange-400/10 flex items-center justify-center">
                    <span className="text-orange-400 text-xs font-medium">Prohibited</span>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Travel booking services with flexible cancellations
                  </div>
                  <div className="w-20 bg-green-500/10 flex items-center justify-center">
                    <span className="text-green-500 text-xs font-medium">Neutral</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <a href="mailto:support@ballerine.com" className="mt-3 mb-1 font-semibold text-sm">
                  Talk to us to learn more
                </a>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <p className="text-sm text-stone-400 mt-1">
        Upload your acceptable use policy and let our AI underwriter determine how the merchant fits
        within it.
      </p>
    </div>
  );
};
